import { FC } from 'react';
import { ReactComponent as AddIcon } from 'resources/images/add.svg';
import { ChakraFabButton } from 'app/components/Core';

interface AddRepresentativeFabProps {
  onClick: () => void;
}

export const AddRepresentativeFab: FC<AddRepresentativeFabProps> = ({
  onClick,
}) => {
  return (
    <ChakraFabButton
      aria-label="add representative"
      onClick={onClick}
      leftIcon={<AddIcon />}
    >
      Add Representative
    </ChakraFabButton>
  );
};
